/*
  Custom Slick Gallery & Two-Way Media/Variant Sync
  Uses custom classes (custom-slick-main-list, custom-slick-thumb-list, custom-slick-thumb-btn, etc.)
  Ensures clicked thumbnail receives active highlight and stays 100% in sync with main gallery & variant pickers.
*/
(function () {
  function initSlickGallery(container) {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      setTimeout(function () {
        initSlickGallery(container);
      }, 100);
      return;
    }

    var $ = jQuery;
    var $gallery = container ? $(container) : $('media-gallery');

    $gallery.each(function () {
      var $mediaGallery = $(this);
      var idAttr = $mediaGallery.attr('id') || '';
      var sectionId = idAttr.replace('MediaGallery-', '');

      if (!sectionId) return;

      var $mainGallery = $('#Slider-Gallery-' + sectionId);
      var $thumbGallery = $('#Slider-Thumbnails-' + sectionId);

      if ($mainGallery.length === 0) return;

      var initialSlideAttr = parseInt($mediaGallery.attr('data-initial-slide'), 10);
      var startSlide = !isNaN(initialSlideAttr) ? initialSlideAttr : 0;

      // Parse variant mapping JSON
      var variantDataEl = document.getElementById('ProductMediaVariantData-' + sectionId);
      var variantData = null;
      if (variantDataEl) {
        try {
          variantData = JSON.parse(variantDataEl.textContent);
        } catch (e) {
          variantData = null;
        }
      }

      if ($mainGallery.hasClass('slick-initialized')) {
        $mainGallery.slick('unslick');
      }
      if ($thumbGallery.length && $thumbGallery.hasClass('slick-initialized')) {
        $thumbGallery.slick('unslick');
      }

      // Main image slider (NO ARROWS, showing one slide at a time)
      $mainGallery.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: startSlide,
        arrows: false,
        fade: true,
        adaptiveHeight: true
      });

      // Thumbnail slider: 3 vertical items above 989px, 4 horizontal <= 989px
      if ($thumbGallery.length) {
        var isDesktop = window.innerWidth > 989;

        var upSvg = '<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" fill="none" stroke-width="2.5"><path d="M18 15l-6-6-6 6"/></svg>';
        var downSvg = '<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" fill="none" stroke-width="2.5"><path d="M18 9l-6 6-6-6"/></svg>';
        var prevSvg = '<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" fill="none" stroke-width="2.5"><path d="M15 18l-6-6 6-6"/></svg>';
        var nextSvg = '<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" fill="none" stroke-width="2.5"><path d="M9 18l6-6-6-6"/></svg>';

        $thumbGallery.slick({
          slidesToShow: isDesktop ? 3 : 3,
          slidesToScroll: 1,
          initialSlide: startSlide,
          dots: false,
          arrows: true,
          vertical: isDesktop,
          verticalSwiping: isDesktop,
          centerMode: false,
          focusOnSelect: false,
          prevArrow: '<button type="button" class="slick-prev" aria-label="Previous">' + (isDesktop ? upSvg : prevSvg) + '</button>',
          nextArrow: '<button type="button" class="slick-next" aria-label="Next">' + (isDesktop ? downSvg : nextSvg) + '</button>',
          responsive: [
            {
              breakpoint: 990,
              settings: {
                vertical: false,
                verticalSwiping: false,
                slidesToShow: 3,
                prevArrow: '<button type="button" class="slick-prev" aria-label="Previous">' + prevSvg + '</button>',
                nextArrow: '<button type="button" class="slick-next" aria-label="Next">' + nextSvg + '</button>'
              }
            }
          ]
        });
      }

      // Sync active thumbnail highlight exclusively by target index
      function updateActiveThumbnailByIndex(index) {
        if (!$thumbGallery.length) return;
        $thumbGallery.find('.custom-slick-thumb-btn, .thumbnail').removeAttr('aria-current');

        var $targetSlide = $thumbGallery.find('.slick-slide[data-slick-index="' + index + '"]');
        if ($targetSlide.length) {
          $targetSlide.find('.custom-slick-thumb-btn, .thumbnail').attr('aria-current', 'true');
        }

        if ($thumbGallery.hasClass('slick-initialized')) {
          $thumbGallery.slick('slickGoTo', index);
        }
      }

      // Check for unambiguous media-to-variant mapping
      function findUnambiguousVariantForMedia(rawMediaId) {
        if (!variantData || !variantData.variants) return null;
        var matchingVariants = variantData.variants.filter(function (v) {
          return v.featured_media_id && v.featured_media_id.toString() === rawMediaId.toString();
        });
        if (matchingVariants.length === 1) {
          return matchingVariants[0];
        }
        return null;
      }

      function updateVariantSelectionFromMedia(rawMediaId) {
        var targetVariant = findUnambiguousVariantForMedia(rawMediaId);
        if (!targetVariant || !targetVariant.options) return;

        var $variantSelects = $('#variant-selects-' + sectionId);
        if (!$variantSelects.length) {
          $variantSelects = $('variant-selects[data-section="' + sectionId + '"]');
        }

        if ($variantSelects.length && targetVariant.options.length) {
          targetVariant.options.forEach(function (optValue, idx) {
            var $select = $variantSelects.find('select').eq(idx);
            if ($select.length && $select.val() !== optValue) {
              $select.val(optValue);
              $select[0].dispatchEvent(new Event('change', { bubbles: true }));
            }
            var $radio = $variantSelects.find('fieldset').eq(idx).find('input[type="radio"][value="' + optValue.replace(/"/g, '\\"') + '"]');
            if ($radio.length && !$radio.is(':checked')) {
              $radio.prop('checked', true);
              $radio[0].dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        }
      }

      // Core function: Set Active Media by matching data-media-id in both carousels
      function safeSetActiveMedia(mediaId, isUserInitiated) {
        if (!mediaId) return;

        // Auto-recovery if DOM structure was swapped
        if ($mainGallery.children('li:not(.slick-slide)').length > 0 || ($thumbGallery.length && $thumbGallery.children('li:not(.slick-slide)').length > 0)) {
          initSlickGallery($mediaGallery[0]);
          return;
        }

        var mediaIdStr = mediaId.toString();
        var rawId = mediaIdStr.split('-').pop();

        // 1. Locate slide in Main Gallery
        var $mainSlide = $mainGallery.find('.slick-slide:not(.slick-cloned)').filter(function () {
          var mid = $(this).attr('data-media-id') || $(this).find('[data-media-id]').attr('data-media-id') || $(this).attr('data-target') || $(this).find('[data-target]').attr('data-target') || '';
          return mid.toString().indexOf(rawId) !== -1;
        }).first();

        if ($mainSlide.length) {
          var mainIndex = parseInt($mainSlide.attr('data-slick-index'), 10);
          if (!isNaN(mainIndex)) {
            $mainGallery.slick('slickGoTo', mainIndex);
          }
        }

        // 2. Locate slide in Thumbnail Gallery
        if ($thumbGallery.length) {
          var $thumbSlide = $thumbGallery.find('.slick-slide:not(.slick-cloned)').filter(function () {
            var mid = $(this).attr('data-media-id') || $(this).find('[data-media-id]').attr('data-media-id') || $(this).attr('data-target') || $(this).find('[data-target]').attr('data-target') || '';
            return mid.toString().indexOf(rawId) !== -1;
          }).first();

          if ($thumbSlide.length) {
            var thumbIndex = parseInt($thumbSlide.attr('data-slick-index'), 10);
            if (!isNaN(thumbIndex)) {
              updateActiveThumbnailByIndex(thumbIndex);
            }
          }
        }

        if (isUserInitiated) {
          updateVariantSelectionFromMedia(rawId);
        }
      }

      // Sync thumbnails when main gallery slide changes
      $mainGallery.off('beforeChange.customSlick').on('beforeChange.customSlick', function (event, slick, currentSlide, nextSlide) {
        updateActiveThumbnailByIndex(nextSlide);
      });

      // Handle thumbnail clicks
      $mediaGallery.off('click.customSlick').on('click.customSlick', '.custom-slick-thumb-item, .custom-slick-thumb-btn, .thumbnail-list__item, .thumbnail', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $slide = $(this).closest('.slick-slide');
        var slideIndex = $slide.attr('data-slick-index');

        if (slideIndex !== undefined && slideIndex !== null) {
          var numericIndex = parseInt(slideIndex, 10);
          if (!isNaN(numericIndex)) {
            $mainGallery.slick('slickGoTo', numericIndex);
            updateActiveThumbnailByIndex(numericIndex);

            var rawMediaId = $slide.attr('data-media-id') || $slide.find('[data-media-id]').attr('data-media-id') || $slide.attr('data-target') || $slide.find('[data-target]').attr('data-target');
            if (rawMediaId) {
              updateVariantSelectionFromMedia(rawMediaId.toString().split('-').pop());
            }
          }
        }
      });

      // Direct Variant Option Click Listener
      $(document).off('click.variantOption-' + sectionId).on('click.variantOption-' + sectionId, '#variant-selects-' + sectionId + ' [data-media-id], variant-selects[data-section="' + sectionId + '"] [data-media-id]', function () {
        var mediaId = $(this).attr('data-media-id');

        var optionName = $(this).attr('data-option-name');
        console.log('media item: ', this)
        console.log('optionName ', optionName)
        if (optionName == 'Size') {
          return;
        }

        if (mediaId) {
          safeSetActiveMedia(mediaId, false);
        }
      });

      // Window resize handling for vertical/horizontal breakpoint
      $(window).off('resize.customSlick-' + sectionId).on('resize.customSlick-' + sectionId, function () {
        var isDesktopNow = window.innerWidth > 989;
        if ($thumbGallery.length && $thumbGallery.hasClass('slick-initialized')) {
          var currentVertical = $thumbGallery.slick('slickGetOption', 'vertical');
          if (currentVertical !== isDesktopNow) {
            $thumbGallery.slick('slickSetOption', 'vertical', isDesktopNow, true);
            $thumbGallery.slick('slickSetOption', 'verticalSwiping', isDesktopNow, true);
            $thumbGallery.slick('slickSetOption', 'slidesToShow', isDesktopNow ? 3 : 3, true);
          }
        }
      });

      // Override Dawn WebComponent's setActiveMedia
      var mediaGalleryEl = document.getElementById('MediaGallery-' + sectionId);
      if (mediaGalleryEl) {
        mediaGalleryEl.setActiveMedia = function (mediaId, prepend) {
          safeSetActiveMedia(mediaId, false);
        };
      }

      // Variant change event handlers
      function handleVariantChange(variant) {
        if (!variant) return;
        var mediaId = variant.featured_media ? variant.featured_media.id : (variant.featured_image ? variant.featured_image.id : null);
        if (mediaId) {
          safeSetActiveMedia(mediaId, false);
        }
      }

      ['variant:change', 'variant:changed', 'product:variant-change'].forEach(function (eventType) {
        document.addEventListener(eventType, function (e) {
          var variant = e.detail ? (e.detail.variant || e.detail) : null;
          if (variant) {
            handleVariantChange(variant);
          }
        });
      });
    });
  }

  window.initCustomSlickGallery = initSlickGallery;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSlickGallery();
    });
  } else {
    initSlickGallery();
  }
})();
